import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage: 'linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(40,40,40,0.9) 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: '" "',
          zIndex: 1,
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.75,
        },
      }}
    >
      <Box position="relative" zIndex={2} width="100%">
        <Container>
          <Box textAlign="center" color="common.white">
            <Box
              sx={{
                backgroundImage: 'url(/images/logos/logo_white.PNG)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 80, md: 120 },
                maxWidth: 320,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
            >
              Propuesta de Cobertura 360
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center">
              Actitud Plateada
              <br />
              2026
            </Typography>
            <Typography variant="h6" component="p" align="center" sx={{ fontWeight: 400, opacity: 0.95 }}>
              TNO Network x Torneo de Pickleball & Pádel 55+
            </Typography>
            <Typography variant="body1" align="center" sx={{ mt: 2, opacity: 0.9, maxWidth: 560, mx: 'auto' }}>
              Estilo de vida premium y longevidad activa. Autoridad y modernidad en cada raqueta.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
